/* tslint:disable */
/* eslint-disable */
/**
 * Documents API
 * CDI Documents API
 *
 * The version of the OpenAPI document: 1.33.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from '../runtime';
import { DocumentArticleAllOfResourceSourcesFromJSON, DocumentArticleAllOfResourceSourcesFromJSONTyped, DocumentArticleAllOfResourceSourcesToJSON } from './DocumentArticleAllOfResourceSources';
/**
 * Check if a given object implements the DocumentArticleAllOfResource interface.
 */
export function instanceOfDocumentArticleAllOfResource(value) {
    let isInstance = true;
    isInstance = isInstance && 'sources' in value;
    return isInstance;
}
export function DocumentArticleAllOfResourceFromJSON(json) {
    return DocumentArticleAllOfResourceFromJSONTyped(json, false);
}
export function DocumentArticleAllOfResourceFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        storeSources: !exists(json, 'storeSources') ? undefined : json['storeSources'],
        sources: json['sources'].map(DocumentArticleAllOfResourceSourcesFromJSON)
    };
}
export function DocumentArticleAllOfResourceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        storeSources: value.storeSources,
        sources: value.sources.map(DocumentArticleAllOfResourceSourcesToJSON)
    };
}
